import React, { useEffect, useRef, useState } from "react";
import Odd, { getOddDesc } from "./Odd";
import Img from "./Img";
import { classIf } from "../data/utils";

export default function OddSelector(props) {
    const [toggled, setToggled] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const listener = () => {
            setToggled(false);
        }
        const el = ref.current;
        el.addEventListener('blur', listener);
        return () => el.removeEventListener('blur', listener);
    }, []);

    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        setToggled(!toggled);
    }
    
    const [selected, setSelected] = useState(0);
    const odds = props.odds.filter(o => o.value != null);
    const odd = props.odds[selected];
    const desc = getOddDesc(odd, false);

    return (
        <div className="c_56" onClick={handleClick} ref={ref} tabIndex={0}>
            <div className="c_56_1">
                <div className="c_56_1_1">{desc}</div>
                <Img className="c_56_1_2" src="icon_chevron.svg" height="16px" width="16px" data-rotate={toggled ? '180' : ''} />
            </div>
            <Odd data={odd} type={2} />
            {toggled &&
                <div className="c_56_3">
                    {odds.map((o, i) =>
                        <div key={o.uniqueId} className={"c_56_3_1" + classIf(selected === i, 'active')} onClick={() => setSelected(i)}>
                            <div className="c_56_3_1_1">{getOddDesc(o)}</div>
                            <Odd data={o} type={2} />
                            {/* <div className="c_56_3_1_2"></div> */}
                        </div>
                    )}
                </div>
            }
        </div>
    );
}
